import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";
import {update} from "../../../app/setters/update.js";
import {useNavigate} from "react-router-dom";

export const useZlozKarteProjektu = () => {
const navigate = useNavigate();

    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => update(`/${MAIN_REJESTR_API_SHORT}/zloz`, data),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_projektow__/rejestr/lista`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
            navigate(-1)
        },
    });
};
